/**
 * Labstep
 */

export const DATA_TEST_ID = {
  action_component: 'global-search',
};
